"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAccordion = void 0;
var _react = require("react");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var useAccordion = exports.useAccordion = function useAccordion(detailsRef, summaryRef, contentRef) {
  var _detailsRef$current;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    animation = _useState2[0],
    setAnimation = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isExpanding = _useState4[0],
    setIsExpanding = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isClosing = _useState6[0],
    setIsClosing = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    chevronUp = _useState8[0],
    setChevronUp = _useState8[1];
  var animationOptions = {
    duration: 800
  };
  var handleAnimatedFinished = (0, _react.useCallback)(function (open) {
    var $detail = detailsRef.current;
    if ($detail) {
      $detail.open = open;
      setAnimation(undefined);
      setIsClosing(false);
      setIsExpanding(false);
      $detail.style.height = '';
      $detail.style.overflow = '';
    }
  }, []);
  var expand = (0, _react.useCallback)(function () {
    var $detail = detailsRef.current;
    var $content = contentRef.current;
    if ($detail && $content) {
      setIsExpanding(true);
      setChevronUp(true);
      var startHeight = "".concat($detail.offsetHeight, "px");
      var endHeight = "".concat($detail.offsetHeight + $content.offsetHeight, "px");
      var bounceHeight = "".concat($detail.offsetHeight + $content.offsetHeight + 10, "px");
      if (animation) {
        animation.cancel();
      }
      if ($detail.animate) {
        var runningAnimation = $detail.animate([{
          height: startHeight,
          easing: 'ease-in-out'
        }, {
          height: bounceHeight,
          easing: 'ease-in-out'
        }, {
          height: endHeight
        }], animationOptions);
        var contentAnimation = $content.animate([{
          height: '0px',
          easing: 'ease-in-out'
        }, {
          height: "".concat($content.offsetHeight + 10, "px"),
          easing: 'ease-in-out'
        }, {
          height: "".concat($content.offsetHeight, "px")
        }], animationOptions);
        setAnimation(runningAnimation);
        setAnimation(contentAnimation);
        runningAnimation.onfinish = function () {
          return handleAnimatedFinished(true);
        };
        runningAnimation.oncancel = function () {
          return setIsExpanding(false);
        };
      } else {
        $detail.style.height = endHeight;
        $content.style.height = "".concat($content.offsetHeight, "px");
        handleAnimatedFinished(true);
      }
    }
  }, [animation, handleAnimatedFinished]);
  var shrink = (0, _react.useCallback)(function () {
    var $detail = detailsRef.current;
    var $summary = summaryRef.current;
    setChevronUp(false);
    if ($detail && $summary) {
      setIsClosing(true);
      var startHeight = "".concat($detail.offsetHeight, "px");
      var bounceHeight = "".concat($summary.offsetHeight - 10, "px");
      var endHeight = "".concat($summary.offsetHeight, "px");
      if (animation) {
        animation.cancel();
      }
      if ($detail.animate) {
        var runningAnimation = $detail.animate([{
          height: startHeight,
          easing: 'ease-in-out'
        }, {
          height: bounceHeight,
          easing: 'ease-in-out'
        }, {
          height: endHeight
        }], animationOptions);
        setAnimation(runningAnimation);
        runningAnimation.onfinish = function () {
          return handleAnimatedFinished(false);
        };
        runningAnimation.oncancel = function () {
          return setIsClosing(false);
        };
      } else {
        $detail.style.height = endHeight;
        handleAnimatedFinished(false);
      }
    }
  }, [animation, handleAnimatedFinished]);
  var open = (0, _react.useCallback)(function () {
    var $detail = detailsRef.current;
    if ($detail) {
      $detail.style.height = "".concat($detail.offsetHeight, "px");
      $detail.open = true;
      window.requestAnimationFrame(function () {
        return expand();
      });
    }
  }, [expand]);
  var handleClick = (0, _react.useCallback)(function (e) {
    e.preventDefault();
    var $detail = detailsRef.current;
    if (isExpanding || isClosing) {
      return;
    }
    if ($detail) {
      $detail.style.overflow = 'hidden';
      if (isClosing || !$detail.open) {
        open();
      } else if (isExpanding || $detail.open) {
        shrink();
      }
    }
  }, [open, shrink, isClosing, isExpanding]);
  return {
    handleClick: handleClick,
    isOpen: (_detailsRef$current = detailsRef.current) === null || _detailsRef$current === void 0 ? void 0 : _detailsRef$current.open,
    isChevronUp: chevronUp
  };
};